// The good path's payphone and the missing-person flyer (docs/06 §4, §8). Dolores only calls
// during an intermission; the flyer's folded page is Ledger page 1.
import { LEDGER_PAGES } from '../../content/registry';
import { phoneKeys, type PhoneScript } from '../../content/phone';
import { t } from '../../i18n/t';
import { controller } from '../../render';
import { modsOf } from '../../state/selectors';
import { setUI, useGame, useUI } from '../../state/store';
import { Btn, Frame, Icon } from '../common';

/** Bottom-left corner of the intermission: the ringing payphone and the flyer on the wall. */
export function WallCorner() {
  const game = useGame((g) => g);
  const im = game.run?.intermission;
  if (!im) return null;
  const eyes = modsOf(game).features.has('eyes');
  const flyer = eyes && !game.meta.lifetime.ledgerPages.includes(LEDGER_PAGES[0]!.id);
  const ringing = im.phone && !im.phone.answered;
  if (!ringing && !flyer) return null;
  return (
    <div className="row" style={{ position: 'absolute', left: 10, bottom: 8, gap: 8, alignItems: 'flex-end' }}>
      {ringing && (
        <Frame>
          <div className="row" style={{ gap: 6 }}>
            <span className="shake-soft">
              <Icon id="item_phone" />
            </span>
            <div className="col" style={{ gap: 3 }}>
              <span style={{ color: '#8fd3ff' }}>{t('ui.phone.ring')}</span>
              <Btn kind="primary" onClick={() => controller.act({ t: 'ANSWER_PHONE' })} testId="answer-phone">
                {t('ui.phone.answer')}
              </Btn>
            </div>
          </div>
        </Frame>
      )}
      {flyer && (
        <button className="flyer-btn" onClick={() => setUI({ flyer: true })} data-testid="flyer">
          <Icon id="flyer" />
        </button>
      )}
    </div>
  );
}

export function PhoneCall() {
  const call = useUI((u) => u.call);
  if (!call) return null;
  return (
    <div className="overlay interactive" style={{ flexDirection: 'column', gap: 8, zIndex: 20 }} data-testid="phone-call">
      <Icon id="payphone" scale={2} />
      <div className="dim">{t('ui.phone.calling')}</div>
      <div className="h" style={{ color: '#8fd3ff' }}>
        {t('ui.phone.dolores')}
      </div>
      <div className="col" style={{ gap: 4, alignItems: 'center', width: 420 }}>
        {phoneKeys(call as PhoneScript).map((k, i) => (
          <div key={k} className="dolores fade-in" style={{ animationDelay: `${i * 1100}ms`, textAlign: 'center' }}>
            {t(k)}
          </div>
        ))}
      </div>
      <Btn onClick={() => setUI({ call: null })} testId="hang-up">
        {t('ui.phone.hangup')}
      </Btn>
    </div>
  );
}

export function Flyer() {
  const open = useUI((u) => u.flyer);
  if (!open) return null;
  return (
    <div className="overlay interactive" style={{ flexDirection: 'column', gap: 8, zIndex: 20 }} data-testid="flyer-open">
      <div className="flyer-paper col">
        <div className="h">{t('ui.flyer.title')}</div>
        <div className="flyer-photo" />
        <div style={{ lineHeight: '11px' }}>{t('ui.flyer.body')}</div>
        <div className="h">{t('ui.flyer.number')}</div>
        <div className="dim-ink">{t('ui.flyer.page')}</div>
      </div>
      <div className="row" style={{ gap: 8 }}>
        <Btn
          kind="primary"
          onClick={() => {
            controller.act({ t: 'READ_FLYER' });
            setUI({ flyer: false, panel: 'ledger' });
          }}
          testId="read-flyer"
        >
          {t('ui.flyer.read')}
        </Btn>
        <Btn onClick={() => setUI({ flyer: false })}>{t('ui.flyer.close')}</Btn>
      </div>
    </div>
  );
}
